import * as React from "react";
import * as speakers from "./style.module.scss";
export const Speaker = () => {
  return (
    <section className={speakers.speakers}>
      <div className="container">
        <ul className={speakers.list}>
          <li>
            <h2>Ведущий</h2>
            <img src="https://fs.advance.ru/landing-pages/marathon/marathon_intellektualnyj_privedi_svoj_mozg_v_tonus/az-violet.png" alt=""/>
            <div className={speakers.info}>
              <h3>Александр Згода</h3>
              <p>Генеральный и&nbsp;академический директор Advance</p>
              <ul>
                <li>Специалист в области личной эффективности и ускоренного обучения</li>
                <li>Окончил школу в 14 лет, в 2004 году окончил юрфак СПбГУ со средним баллом 4,8 — в 20 лет</li>
                <li>В 21 год открыл собственную юридическую компанию, в 24 года стал топ-менеджером финской компании Konecranes</li>
                <li>С декабря 2016 года генеральный директор Advance</li>
                <li>С 2020 года региональный эксперт АСИ в области образования и амбассадор АСИ в области корпоративного управления</li>
                <li>Соавтор бестселлера «Энциклопедия детской мотивации»</li>
                <li>Кандидат в мастера спорта по гиревому спорту, марафонец</li>
              </ul>
            </div>
          </li>
          <li>
            <h2>Соведущая</h2>
            <img src="https://fs.advance.ru/landing-pages/marathon/marathon_intellektualnyj_privedi_svoj_mozg_v_tonus/mb-red.png" alt=""/>
            <div className={speakers.info}>
              <h3>Мария Баужес</h3>
              <p>Руководитель клиентского отдела Advance</p>
              <ul>
                <li>Выносит самые животрепещущие вопросы студентов в прямой эфир</li>
                <li>Занимается сопровождением учащихся с 2015 года</li>
                <li>Знает всё о мотивации в образовании</li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </section>
  );
};
